var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 59,
    viewBox: "0 0 75 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.232 0.880127H5.62915C3.03445 0.880127 0.930664 2.98378 0.930664 5.57848V53.7373C0.930664 56.3319 3.03445 58.4355 5.62915 58.4355H70.232C72.8269 58.4355 74.9307 56.3319 74.9307 53.7372V5.57848C74.9307 2.98378 72.827 0.880127 70.232 0.880127ZM70.232 5.57848V39.7488L60.9727 31.3304C59.5809 30.0654 57.4407 30.1159 56.1111 31.4468L46.7399 40.8165L28.2625 18.7457C26.8658 17.0778 24.3075 17.0614 22.8899 18.7093L5.62915 38.7693V5.57848H70.232ZM50.264 17.9118C50.264 14.3433 53.1557 11.4515 56.7241 11.4515C60.2927 11.4515 63.1845 14.3433 63.1845 17.9118C63.1845 21.4803 60.2929 24.372 56.7241 24.372C53.1558 24.3722 50.264 21.4803 50.264 17.9118Z",
    fill: "#BFBFBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.b4b73a11bbb8fb631c73255f9849e53a.svg";
export { ForwardRef as ReactComponent };